import { TranslationsNamespaceProvider, TranslationsProvider } from '@ori/i18n';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { StrictMode, Suspense } from 'react';
import { ErrorNotification } from './components';
import { APP_NAME, translationsNamespace } from './constants';
import { getTranslationsProps } from './utils/getTranslationsProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = props => {
  const translationProps = getTranslationsProps(props);
  return /*#__PURE__*/_jsx(StrictMode, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(TestIdProvider, {
        project: APP_NAME,
        team: Team.Checkout,
        children: /*#__PURE__*/_jsx(TranslationsProvider, {
          ...translationProps,
          children: /*#__PURE__*/_jsx(TranslationsNamespaceProvider, {
            namespace: translationsNamespace,
            children: /*#__PURE__*/_jsx(ErrorNotification, {})
          })
        })
      })
    })
  });
};